module.exports = __webpack_public_path__ + "static/img/6fd34035d5e882ca2d745154ce4107c.3ddc611e.jpg";